"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNavItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _VerticalNavItem = require("./VerticalNavItem.styles");
/**
 * A simple container for a `VerticalNav` item. Usually has an `Anchor` or an
 * `UnstyledButton` as a child.
 *
 * @since 8.72.0
 */

var VerticalNavItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_VerticalNavItem.StyledVerticalNavItem, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.VerticalNavItem = VerticalNavItem;
VerticalNavItem.displayName = 'VerticalNavItem';
VerticalNavItem.propTypes = {
  /**
   * If true, displays the item in its "disabled" state.
   */
  'aria-disabled': _propTypes.default.bool,
  /**
   * If true, displays the item in its "selected" state.
   *
   * This should only be used if the nav item is like a tab
   */
  'aria-selected': _propTypes.default.bool,
  /**
   * If anything but false, displays the item in its "selected" state.
   *
   * Don't use aria-current as a substitute for aria-selected in gridcell, option, row or tab
   */
  'aria-current': _propTypes.default.oneOf(['page', 'step', 'location', 'date', 'time', 'true', 'false', true, false]),
  /**
   * Item text content.
   */
  'children': _propTypes.default.node.isRequired,
  /**
   * Nav items have the role of `"menuitem"` by default per the
   * [accesibility guidelines](https://www.w3.org/WAI/ARIA/apg/example-index).
   */
  'role': _propTypes.default.string
};
VerticalNavItem.defaultProps = {
  role: 'menuitem'
};